import React from "react";

import Router from "./utils/Router";

function App() {
  return <Router />;
}

export default App;
